import { Grid, Paper } from "@mui/material";
import LinkIcon from "@mui/icons-material/Link";
import PlanHeader from "../../../shared/enrollment/planCode/PlanHeader";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import EditIcon from "@mui/icons-material/Edit";
import { useContext, useCallback, useMemo } from "react";
import downloadFile from "../../../../utils/commonFunctions/downloadFile";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "../../../../contexts";
import { AcknowledgementProps } from "../../../../types/components/enrollmentProps.types";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import PanToolIcon from "@mui/icons-material/PanTool";
import ClearIcon from "@mui/icons-material/Clear";
import {
	CancerBrochure,
	WholeLifeBrochure,
	CriticalIllnessBrochure,
	KemperShortTermBrochure,
	KemperAccidentBrochure,
	HospitalndemnityBrochure,
	GroupLifeIndemnity,
	FamilyProtection,
	DocRx,
	Vision,
	DentalPlan
} from "../../../../assets";
import "./enrollmentAcknowledgement.css";
import { Status } from "../../../../types/enrollment.types";
import { dateTimeZoneConverter, getFirstOfNextMonth } from "../../../../utils/commonFunctions/date";
import VEBPlanHeader from "../../../shared/enrollment/VEBPlanHeader/PlanHeader";
import { VEBPlanCodes2024 } from "../../../../constants/VEBPlanCodes/VEBPlanCodes2024";
import { VEBYearlyOpenAndCurrentEffectiveDate } from "../../../../constants/VEBYearlyOpenAndCurrentDate";

type StatusIcon = {
	[key in Status]: JSX.Element;
};

type StatusMessage = {
	[key in Status]: string;
};

const statusIcon: StatusIcon = {
	ACTIVE: <DoneAllIcon className="thank-icon" />,
	SUBMITTED: <DoneOutlineIcon className="thank-icon" />,
	REJECTED: <ClearIcon className="thank-icon" />,
	WAIVED: <PanToolIcon className="thank-icon" />,
	OPENED: <></>,
	CLOSED: <></>,
	"WAIVED - WAITING FOR APPROVAL": <></>
};

const statusMessage: StatusMessage = {
	ACTIVE: "Your enrollment is successfully Activated",
	SUBMITTED: "Your enrollment has been successfully Submitted",
	REJECTED: "Your enrollment has been Rejected",
	WAIVED: "You enrollment is successfully waived",
	OPENED: "",
	CLOSED: "",
	"WAIVED - WAITING FOR APPROVAL": ""
};

const EnrollmentAcknowledgement = ({
	idCardAccessPointRequired,
	dependentChangePointRequired,
	carrierPhoneNo,
	carrierWebsite,
	planDocument,
	planName,
	addDependentLink,
	removeDependentLink,
	planCode,
	status
}: AcknowledgementProps): JSX.Element => {
	const { theme } = useContext(ThemeContext);
	const location = useLocation();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	// console.log("status", status);

	const handlePlanBrochureDownload = useCallback(() => {
		const step = urlSearchParams.get("step");
		switch (step) {
			case "Cancer":
				downloadFile(CancerBrochure, "MedMutual_Cancer_Plan_Brochure");
				break;
			case "Whole life":
				downloadFile(WholeLifeBrochure, "MedMutual_Whole_Life_Plan_Brochure");
				break;
			case "Critical Illness":
				downloadFile(CriticalIllnessBrochure, "MedMutual_Critical_Illness_Plan_Brochure");
				break;
			case "Short Term Disability":
				downloadFile(KemperShortTermBrochure, "MedMutual_Short_Term_Brochure");
				break;
			case "Accident":
				downloadFile(KemperAccidentBrochure, "MedMutual_Accident_Plan_Brochure");
				break;
			case "Hospital Indemnity":
				downloadFile(HospitalndemnityBrochure, "MedMutual_Hospital_Indemnity_Plan_Brochure");
				break;
			case "Group Life Indemnity":
				downloadFile(GroupLifeIndemnity, "Group_Life_Indemnity_Plan_Brochure");
				break;
			case "Family Protection":
				downloadFile(FamilyProtection, "Family_Protection_Plan_Brochure");
				break;
			case "Doc and Rx":
				downloadFile(DocRx, "Doc_&_Rx_Plan_Brochure");
				break;
			case "Vision":
				downloadFile(Vision, "Vision_Plan_Brochure");
				break;
			case "Dental":
				downloadFile(DentalPlan, "Dental_Plan_Brochure_All");
				// downloadFile(DentalPlan2, "Dental Plan Brochure");
				// downloadFile(DentalPlan3, "Dental Plan Brochure");
				break;
		}
	}, [urlSearchParams]);

	console.log("planme------------>222", planName);

	return (
		<div className="enrollment-acknowledgement">
			<VEBPlanHeader
				effectiveDate={
					planCode
						? VEBPlanCodes2024.includes(planCode as unknown as string)
							? VEBYearlyOpenAndCurrentEffectiveDate.veb_current_effective_date_MMDDYYYY
							: VEBYearlyOpenAndCurrentEffectiveDate.veb_yearly_open_effective_date_MMDDYYYY
						: "N/A"
				}
				planName={planName}
				planCode={planCode ? (planCode as unknown as string) : "No Plan is Opened"}
			/>
			<div className="theme-plan-section-margin" />
			{!["OPENED", "CLOSED"].includes(status) ? (
				<>
					<Grid container direction="column" alignItems="center">
						{statusIcon[status as keyof StatusIcon]}
					</Grid>
					<div className="thank-note">{statusMessage[status as keyof StatusMessage]}</div>
				</>
			) : null}
			<div className="theme-plan-section-margin" />
			<div className="theme-plan-icon-item-container">
				<div>
					<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
				</div>
				<div className="theme-plan-point-text">
					<span>If you want to download the Plan Document,</span>
					<span
						style={{ color: theme.primary_color, cursor: "pointer", fontWeight: "800" }}
						onClick={handlePlanBrochureDownload}
					>
						Click Here
					</span>
				</div>
			</div>
			{idCardAccessPointRequired ? (
				<>
					<div className="theme-plan-icon-item-container">
						<div>
							<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-point-text">
							If you want to access the Temp ID card, Please click on `&quot;`Generate ID Card`&quot;`
							button from your home page.
						</div>
					</div>
				</>
			) : null}
			{dependentChangePointRequired ? (
				<>
					<div className="theme-plan-icon-item-container">
						<div>
							<EditIcon className="event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-point-text">
							If you want to make any changes for your dependent, please follow the below details -
						</div>
					</div>

					<div className="theme-plan-icon-item-container" style={{ marginLeft: "30px" }}>
						<div>
							<ControlPointIcon className="sub-event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-subpoint-text">
							If you want to add a new dependent,{" "}
							<a style={{ color: theme.primary_color }} href={addDependentLink}>
								Click Here
							</a>{" "}
							(Remember, if you want to add a dependent due to a special event e.g. Marrige, Birth of a
							Child, you need to provide a document related to that event/s)
						</div>
					</div>
					{/* <div className="theme-plan-icon-item-container" style={{ marginLeft: "30px" }}>
						<div>
							<ControlPointIcon className="sub-event-icon" style={{ color: theme.primary_color }} />
						</div>
						<div className="theme-plan-subpoint-text">
							If you want to remove a dependent from the existing benefit,{" "}
							<a style={{ color: theme.primary_color }} href={removeDependentLink}>
								Click Here
							</a>{" "}
							(Remeber, if you want to remove a dependent due to any special event, you need to provide a
							document related to that event/s)
						</div>
					</div> */}
				</>
			) : null}
			<div className="theme-plan-section-margin" />
			<div className="theme-plan-icon-item-container">
				<div>
					<LinkIcon className="link-icon" />
				</div>
				<div className="link-text">
					For more details related to plan, please contact{" "}
					<span style={{ color: theme.primary_color }}>{carrierPhoneNo}</span> or visit the website{" "}
					<a
						style={{ color: theme.primary_color }}
						href="https://www.brookshirebrothers.com"
						target="_blank"
						rel="noopener noreferrer"
					>
						{carrierWebsite}
					</a>
				</div>
			</div>
		</div>
	);
};

export default EnrollmentAcknowledgement;
